/* ============================================================
   MECHANICS IN MOTION — Landing Page (v2)
   Mobile nav, header disclosures, contestant lightbox, year stamp
   ============================================================ */

(() => {
  "use strict";

  /* ------------------------------------------------------------
     CONTESTANT DATA

     Keys MUST match the `data-mech-name` on each card in index.html,
     which in turn matches the name printed on the card artwork.
     Five of those differ from the spelling used in the supplied bios
     (see instructions/OPEN-ITEMS.md) — the artwork spelling wins here
     so the modal title matches the card the visitor just clicked.

     `video` takes the YouTube ID only — for
     https://www.youtube.com/watch?v=qZq7VCPmi3Y  it is "qZq7VCPmi3Y".
     Leave it "" and the modal shows a "video coming soon" panel.

     `vote` takes that contestant's own full voting URL. Leave it ""
     and the "Vote for me" button still renders and is clickable, but
     points at "#" and does nothing until a real URL is filled in.
     ------------------------------------------------------------ */
  const MECHANICS = {
    "Oniel Hobson": {
      age: 33,
      parish: "St. James",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I have been doing mechanics for about 10 years."],
        ["Hidden talent", "I’m the best singer in the shower."],
        ["People would be surprised to learn", "I previously worked at a corporate job before leaving because I was unfulfilled."],
        ["Ultimate mechanic superpower", "Spatial intelligence."],
        ["Why he wants to win", "I want viewers to see my love for the work, and I believe my passion will shine through on screen. Winning would also help me to procure more tools."]
      ]
    },

    "Micheal Bennett": {
      age: 31,
      parish: "Manchester",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I have been doing mechanics since I was about 12 years old."],
        ["Hidden talent", "Being able to sew."],
        ["People would be surprised to learn", "My wife was the one who signed me up for the competition."],
        ["Ultimate mechanic superpower", "Making the perfect tool for every situation."],
        ["Why he wants to win", "I want to gain more exposure and showcase my skills. I also want to invest in my brand and move from the status of an employee to an employer, while helping the younger generation of mechanics."]
      ]
    },

    "Sean McDonald": {
      age: 51,
      parish: "Kingston",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I have been doing mechanics since I was just 3 years old."],
        ["Hidden talent", "I haven’t found it yet."],
        ["People would be surprised to learn", "I love to sing, although I admit I don't sing very well."],
        ["Ultimate mechanic superpower", "Problem-solving."],
        ["Why he wants to win", "I want to invest in tooling to be better enabled to work more efficiently."]
      ]
    },

    "Oshin Lawrence": {
      age: 32,
      parish: "St. Catherine",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I’m one of only two women competing in Season 2."],
        ["Hidden talent", "I do freelance modeling."],
        ["People would be surprised to learn", "I know how to use a scan tool and do programming."],
        ["Ultimate mechanic superpower", "Solving electrical problems in less than 2 seconds."],
        ["Why she wants to win", "I want to prove that women can succeed in the automotive industry and further my automotive studies overseas."]
      ]
    },

    "Bradly Baker": {
      age: 25,
      parish: "St. Ann",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I’m an athlete."],
        ["Hidden talent", "Critical thinking."],
        ["People would be surprised to learn", "I first became interested in mechanics at around 8 years old."],
        ["Ultimate mechanic superpower", "Scan power."],
        ["Why he wants to win", "I want to gain exposure for my business and help fund my dream of offering mobile mechanical services. I would also put the prize money towards purchasing a car."]
      ]
    },

    "Melvin Harris": {
      age: 21,
      parish: "St. Catherine",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I played for Jamaica's national rugby team last year."],
        ["Hidden talent", "I’m a skilled rugby player."],
        ["People would be surprised to learn", "I have been practicing mechanics since I was only 12 years old."],
        ["Ultimate mechanic superpower", "Diagnosis."],
        ["Why he wants to win", "I want to showcase my passion for mechanics and my ability to solve problems precisely. I also wish to upgrade my tool collection."]
      ]
    },

    "Amanda Clarke": {
      age: 28,
      parish: "Kingston",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I have been in the industry for 10 years."],
        ["Hidden talent", "Writing."],
        ["People would be surprised to learn", "I wanted to be a police officer."],
        ["Ultimate mechanic superpower", "Being able to talk to the parts of the car."],
        ["Why she wants to win", "I want to take a chance on myself and gain exposure. I also wish to buy additional tools and launch a mobile service business."]
      ]
    },

    "O’Neill Harrison": {
      age: 35,
      parish: "St. Catherine",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I love to laugh."],
        ["Hidden talent", "Drawing."],
        ["People would be surprised to learn", "I used to take apart electronic items as a child just to figure out how they worked."],
        ["Ultimate mechanic superpower", "Problem-solving."],
        ["Why he wants to win", "I have a love for mechanics and want to continue to show my skills. I also wish to complete the restoration of my 95 Integra (a classic vehicle) and purchase more tools."]
      ]
    },

    "O’Neil Williams": {
      age: 47,
      parish: "St. Catherine",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I knew I wanted to be a mechanic since I was just 15 years old."],
        ["Hidden talent", "Drumming."],
        ["People would be surprised to learn", "I love to laugh."],
        ["Ultimate mechanic superpower", "I can correct any problem in 1 minute."],
        ["Why he wants to win", "I see winning as a valuable opportunity and resume boost. It will also allow me to repair my mobile vehicle and purchase new equipment."]
      ]
    },

    "Antonio Spence": {
      age: 34,
      parish: "St. Catherine",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I deliberately keep myself clean and presentable to challenge the stereotype that mechanics are always dirty or unkempt."],
        ["Hidden talent", "Computer repairs."],
        ["People would be surprised to learn", "I’m naturally very quiet."],
        ["Ultimate mechanic superpower", "Teleportation."],
        ["Why he wants to win", "I want to represent younger mechanics, offer advice and motivate the next generation. I also want to register my company name and invest in my business."]
      ]
    },

    "Allever McDonald": {
      age: 18,
      parish: "St. Catherine",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I’m currently studying at JAGAS for my Level 2 certification in automotive repair."],
        ["Hidden talent", "I can see how things operate mechanically and pick up on it quickly."],
        ["People would be surprised to learn", "I started doing mechanics when I was just 8 years old."],
        ["Ultimate mechanic superpower", "Instant electrical diagnostics."],
        ["Why he wants to win", "I want to prove how much I have grown as a mechanic and showcase the skills I have developed. I also want to help my mom with medical bills and purchase tools."]
      ]
    },

    "Craig Ottey Brown": {
      age: 30,
      parish: "St. Catherine",
      video: "",
      vote: "https://strawpoll.com/kjn1DGw4xyQ",
      facts: [
        ["One fun fact", "I was born in Jamaica, raised in Brooklyn, New York, and returned to Jamaica in 2024."],
        ["Hidden talent", "Being able to troubleshoot anything — sometimes, even people."],
        ["People would be surprised to learn", "I go to the beach about four times a week."],
        ["Ultimate mechanic superpower", "Being able to find every problem the moment I touch something."],
        ["Why he wants to win", "I’m knowledgeable and bring something fun and unique to the competition. I also wish to buy equipment and parts for a race car that I’m building."]
      ]
    }
  };

  const esc = (str) =>
    String(str).replace(/[&<>"']/g, (c) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
    }[c]));

  /* ---------- Mobile nav toggle ---------- */
  const navToggle = document.querySelector(".nav-toggle");
  const nav = document.querySelector("#primary-nav");

  if (navToggle && nav) {
    navToggle.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", String(isOpen));
      if (!isOpen) {
        nav.querySelectorAll("[data-nav-disclosure][open]")
           .forEach((d) => { d.open = false; });
      }
    });

    nav.addEventListener("click", (e) => {
      // Summaries toggle their own panel; only real links close the drawer.
      if (e.target.closest("a") && nav.classList.contains("is-open")) {
        nav.classList.remove("is-open");
        navToggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---------- Header disclosure menus (Products, About Us) ----------
     <details> gives us click-to-open and keyboard activation for free;
     this adds the parts it does not: one panel open at a time, Escape
     to close, outside-click to dismiss, and arrow-key traversal. */
  const disclosures = Array.from(document.querySelectorAll("[data-nav-disclosure]"));

  if (disclosures.length) {
    const closeAll = (except) => {
      disclosures.forEach((d) => { if (d !== except) d.open = false; });
    };

    disclosures.forEach((d) => {
      const summary = d.querySelector("summary");

      d.addEventListener("toggle", () => { if (d.open) closeAll(d); });

      d.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          if (!d.open) return;
          d.open = false;
          summary.focus();
          e.stopPropagation();
          return;
        }

        if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;

        const links = Array.from(d.querySelectorAll(".site-nav__sub a"));
        if (!links.length) return;
        e.preventDefault();

        if (!d.open) {
          d.open = true;
          links[0].focus();
          return;
        }

        const i = links.indexOf(document.activeElement);
        const next = e.key === "ArrowDown"
          ? (i + 1) % links.length
          : (i <= 0 ? links.length - 1 : i - 1);
        links[next].focus();
      });
    });

    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-nav-disclosure]")) closeAll(null);
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeAll(null);
    });
  }

  /* ---------- Contestant lightbox ---------- */
  const lightbox = document.getElementById("mech-lightbox");

  if (lightbox) {
    const dialog = lightbox.querySelector(".lightbox__dialog");
    const titleEl = lightbox.querySelector(".lightbox__title");
    const bioEl = lightbox.querySelector("[data-lightbox-bio]");
    const frame = lightbox.querySelector("[data-lightbox-frame]");
    const voteEl = lightbox.querySelector("[data-lightbox-vote]");
    const closeBtn = lightbox.querySelector(".lightbox__close");
    let lastFocused = null;

    function bioHTML(mech) {
      const meta = [
        mech.age ? "Age " + mech.age : null,
        mech.parish
      ].filter(Boolean).map((t) => `<span>${esc(t)}</span>`).join("");

      const facts = (mech.facts || []).map(
        ([label, value]) => `<dt>${esc(label)}</dt><dd>${esc(value)}</dd>`
      ).join("");

      return (meta ? `<p class="lightbox__meta">${meta}</p>` : "") +
             (facts ? `<dl class="lightbox__facts">${facts}</dl>` : "");
    }

    function open(name, videoOverride) {
      const mech = MECHANICS[name] || {};
      const videoId = videoOverride || mech.video || "";

      lastFocused = document.activeElement;
      titleEl.textContent = name;
      bioEl.innerHTML = bioHTML(mech);

      frame.innerHTML = videoId
        ? `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0"
                   title="${esc(name)}"
                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                   allowfullscreen
                   referrerpolicy="strict-origin-when-cross-origin"></iframe>`
        : `<p class="lightbox__pending">Coming Soon</p>`;

      voteEl.innerHTML = mech.vote
        ? `<a class="btn btn--yellow lightbox__vote-btn" href="${esc(mech.vote)}"
              target="_blank" rel="noopener">Vote for me</a>`
        : `<a class="btn btn--yellow lightbox__vote-btn" href="#"
              data-vote-placeholder>Vote for me</a>`;

      lightbox.hidden = false;
      document.body.classList.add("is-locked");
      closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      frame.innerHTML = "";           // stops playback
      document.body.classList.remove("is-locked");
      if (lastFocused) lastFocused.focus();
    }

    document.querySelectorAll(".mech").forEach((card) => {
      card.addEventListener("click", () => {
        open(card.dataset.mechName || "", card.dataset.mechVideo || "");
      });
    });

    lightbox.querySelectorAll("[data-lightbox-close]").forEach((el) => {
      el.addEventListener("click", close);
    });

    // Placeholder vote buttons stay clickable but must not scroll the page
    // behind the modal. Filling in `vote` replaces them with real links.
    voteEl.addEventListener("click", (e) => {
      if (e.target.closest("[data-vote-placeholder]")) e.preventDefault();
    });

    document.addEventListener("keydown", (e) => {
      if (lightbox.hidden) return;

      if (e.key === "Escape") {
        close();
        return;
      }

      // Keep focus inside the dialog while it is open
      if (e.key === "Tab") {
        const focusable = dialog.querySelectorAll(
          'button, [href], iframe, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });
  }

  /* ---------- Video carousel ----------
     Vanilla port of the original React coverflow
     (assets/images/vid carousal code.html). Same behaviour: the active
     card holds the iframe, every other card is a thumbnail button, and
     paging wraps around.

     Only the active card gets an iframe, so moving off a video destroys
     its player and stops playback — no need to message the old one.

     Autoplay: the first card starts muted, because browsers refuse to
     autoplay with sound. Anything the visitor then selects is a real
     user gesture, so those play unmuted.
     ------------------------------------------------------------ */
  const VIDEOS = [
    { id: "29ZUOkIrLAk", title: "LIG Garage Talks — Episode 1 ft. Rosh & Ziggy D Chemical" },
    { id: "3afmL8r2_Ss", title: "Season 2 — Episode 3: Blindfold Challenge" },
    { id: "3wg-Ntvh4oA", title: "Season 2 — Episode 2: Major Service" },
    { id: "sawAE3lS1s0", title: "Season 2 — Episode 1: What's The Issue?" },
    { id: "gqnNuqkP3QA", title: "Season 2 — Sneak Peek" },
    { id: "x9A8d2g_lKQ", title: "Season 2 — Official Trailer" },
    { id: "_jeurGiyzGo", title: "Season 2 — Teaser Trailer" }
  ];

  const stage = document.querySelector("[data-reel-stage]");

  if (stage && VIDEOS.length) {
    const caption = document.querySelector("[data-reel-caption]");
    const dotsWrap = document.querySelector("[data-reel-dots]");
    const prevBtn = document.querySelector("[data-reel-prev]");
    const nextBtn = document.querySelector("[data-reel-next]");

    let index = 0;
    // First paint autoplays muted; later ones are user-initiated, so they
    // may carry sound. `primed` flips after the first render.
    let primed = false;

    const embed = (video, withSound) =>
      "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(video.id) +
      "?rel=0&playsinline=1&autoplay=1" + (withSound ? "" : "&mute=1");

    // Wrap an index into range, and give the shortest signed distance
    // from the active card so the fan is symmetrical either way round.
    const wrap = (i) => (i % VIDEOS.length + VIDEOS.length) % VIDEOS.length;

    function offsetOf(i) {
      let o = i - index;
      if (o > VIDEOS.length / 2) o -= VIDEOS.length;
      if (o < -VIDEOS.length / 2) o += VIDEOS.length;
      return o;
    }

    function render() {
      stage.innerHTML = "";

      VIDEOS.forEach((video, i) => {
        const offset = offsetOf(i);
        if (Math.abs(offset) > 2) return;          // two neighbours a side

        const card = document.createElement("div");
        card.className = "reel__card" + (offset === 0 ? " reel__card--active" : "");
        card.style.setProperty("--offset", String(offset));
        card.style.setProperty("--scale", offset === 0 ? "1" : ".8");
        card.style.opacity = String(1 - Math.abs(offset) * 0.3);
        card.style.zIndex = String(10 - Math.abs(offset));

        if (offset === 0) {
          const f = document.createElement("iframe");
          f.src = embed(video, primed);
          f.title = video.title;
          f.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
          f.allowFullscreen = true;
          f.referrerPolicy = "strict-origin-when-cross-origin";
          card.appendChild(f);
        } else {
          const b = document.createElement("button");
          b.type = "button";
          b.className = "reel__thumb";
          b.style.backgroundImage =
            "url(https://i.ytimg.com/vi/" + encodeURIComponent(video.id) + "/maxresdefault.jpg)";
          b.setAttribute("aria-label", "Play " + video.title);
          b.innerHTML = '<span class="reel__play" aria-hidden="true"></span>';
          b.addEventListener("click", () => go(i));
          card.appendChild(b);
        }

        stage.appendChild(card);
      });

      if (caption) caption.textContent = VIDEOS[index].title;

      if (dotsWrap) {
        dotsWrap.querySelectorAll(".reel__dot").forEach((d, i) => {
          d.setAttribute("aria-current", String(i === index));
          d.tabIndex = i === index ? 0 : -1;
        });
      }
    }

    function go(i) {
      index = wrap(i);
      primed = true;                 // past the first paint, sound is allowed
      render();
    }

    if (dotsWrap) {
      VIDEOS.forEach((video, i) => {
        const d = document.createElement("button");
        d.type = "button";
        d.className = "reel__dot";
        d.setAttribute("aria-label", video.title);
        d.addEventListener("click", () => go(i));
        dotsWrap.appendChild(d);
      });
    }

    if (prevBtn) prevBtn.addEventListener("click", () => go(index - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => go(index + 1));

    // Arrow keys page the carousel while it has focus within.
    document.querySelector("[data-reel-carousel]")?.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") { e.preventDefault(); go(index - 1); }
      if (e.key === "ArrowRight") { e.preventDefault(); go(index + 1); }
    });

    render();

    // Stop the player once the carousel scrolls away. Rewriting src is the
    // reliable way to kill playback across browsers; the card stays put and
    // simply sits paused, so coming back does not restart it unasked.
    if ("IntersectionObserver" in window) {
      let away = false;
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && !away) {
            away = true;
            const f = stage.querySelector("iframe");
            if (f) f.src = f.src.replace(/([?&])autoplay=1/, "$1autoplay=0");
          } else if (entry.isIntersecting) {
            away = false;
          }
        });
      }, { threshold: 0.2 }).observe(stage);
    }
  }

  /* ---------- Countdown to kickoff ----------
     Target comes from data-countdown on the section, as an ISO string
     carrying an explicit -05:00 offset (Jamaica, no DST). Parsing it
     that way pins every visitor to the same instant regardless of the
     timezone their device is set to.
     ------------------------------------------------------------ */
  const cd = document.getElementById("countdown");

  if (cd) {
    const target = new Date(cd.dataset.countdown).getTime();
    const grid = cd.querySelector("[data-countdown-grid]");
    const live = cd.querySelector("[data-countdown-live]");
    const srEl = cd.querySelector("[data-countdown-sr]");
    const units = {};
    cd.querySelectorAll("[data-cd]").forEach((el) => { units[el.dataset.cd] = el; });

    // A malformed date would otherwise render "NaN" in every tile.
    if (!Number.isNaN(target)) {
      let lastDays = null;
      let timer = null;

      const pad = (n) => String(n).padStart(2, "0");

      function render() {
        const left = target - Date.now();

        if (left <= 0) {
          if (grid) grid.hidden = true;
          if (live) live.hidden = false;
          if (srEl) srEl.textContent = "The competition has started.";
          clearInterval(timer);
          return;
        }

        const secs = Math.floor(left / 1000);
        const days = Math.floor(secs / 86400);
        const hours = Math.floor(secs / 3600) % 24;
        const mins = Math.floor(secs / 60) % 60;

        if (units.days)    units.days.textContent    = String(days);
        if (units.hours)   units.hours.textContent   = pad(hours);
        if (units.minutes) units.minutes.textContent = pad(mins);
        if (units.seconds) units.seconds.textContent = pad(secs % 60);

        // Announce only when the day rolls over, not every second.
        if (srEl && days !== lastDays) {
          lastDays = days;
          srEl.textContent = days + (days === 1 ? " day" : " days") +
                             " until the competition kicks off.";
        }
      }

      render();
      timer = setInterval(render, 1000);

      // A backgrounded tab throttles the interval, so resync on return.
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) render();
      });
    }
  }

  /* ---------- Footer year stamp ---------- */
  const yearEl = document.getElementById("footer-year");
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());
})();
